// import type {RelatedEmailAddresses} from 'nutshell-graphql-types';

// Recreated from the above type, which is not available to nutshell-core
type RelatedEmailAddresses = {
    primary: EmailAddressEav | null | undefined;
};

type EmailAddressEav = {
    __typename: 'EmailAddressEav';
    isPrimary: boolean;
    value: {
        __typename: 'EmailAddressValue';
        address: string;
        display: string | null | undefined;
        formatted: string;
    };
};

export function getPrimaryEmailAddress(
    emailAddresses: RelatedEmailAddresses
): string | null | undefined {
    if (emailAddresses.primary) {
        const emailAddressObject = emailAddresses.primary.value;

        return emailAddressObject ? emailAddressObject.address : null;
    }

    return null;
}
